import * as z from 'zod';

// Types
import { TitleZod } from '@/types/TitleType';
import { CTAZod } from '@/types/CTAType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

const TextZod = z.object({
  id: z.number(),
  title: TitleZod,
  paragraph: ParagraphZod,
  cta: CTAZod.nullable(),
});

export { TextZod };
export type TextType = z.infer<typeof TextZod>;
